import type { ChannelSummaryType } from 'ChannelSummary/types'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

export interface HeaderAdditionalComponentProps {
  id: string
  onFilter: () => void
}

interface Structure {
  className?: string
  HeaderAdditionalComponent?: (...args: any[]) => JSX.Element
  classNameHeader?: string
  hideDefaultHeader?: boolean
  id: string
  translation?: (string | any)[]
}

interface Props {
  className?: string
  onFilter: () => void
  sortBy: {
    order: string
    value: string
  }
  structure: Structure[]
  type: ChannelSummaryType
}

function TableCommonHeader({ className, onFilter, sortBy, structure }: Props) {
  const { t: translate } = useTranslation()

  return (
    <Box className={classNames('table-common-header', className)}>
      <Box className={classNames('row-wrapper flex-row', sortBy.order)}>
        {structure.map(column => {
          const { classNameHeader, HeaderAdditionalComponent, hideDefaultHeader, id, translation } = column
          const [key, ...translationArgs] = translation || []

          return (
            <Box
              key={id}
              className={classNames(classNameHeader, `cell-header cell-${id} cursor-pointer`, { 'is-active': sortBy.value === id })}
              data-value={id}
              onClick={onFilter}
            >
              {HeaderAdditionalComponent && <HeaderAdditionalComponent {...column} onFilter={onFilter} t={translate} />}

              {!hideDefaultHeader && (
                <Box data-value={id} onClick={onFilter}>
                  {translate(key, ...translationArgs)}
                </Box>
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default TableCommonHeader
